import template from './tsz-team.html';
import './tsz-team.styl';

function controller($rootScope, $tszToast, CompanyService) {

  'ngInject';

  this.team = [];

  /* eslint-disable global-require, import/no-dynamic-require */
  this.getAvatar = (i) => require(`assets/avatars/avatar-${(i % 10) + 1}.png`);

  this.getRandomAvatar = () => {
    const n = 1 + Math.floor(9 * Math.random());
    console.log(n);
    return require(`assets/avatars/avatar-${n}.png`);
  };
  /* eslint-enable global-require import/no-dynamic-require */

  this.loadCompanyUsers = (id) => {
    CompanyService.users(id)
    .then((response) => {
      this.team = response;
    }).catch((err) => {
      console.log(err);
    });
  };

  $rootScope.$on('reloadCompanyUsers', (event, companyId) => {
    console.log('reloadCompanyUsers event received');
    this.loadCompanyUsers(companyId);
  });

  this.resendInvite = (userEmail) => {
    const invitation = {
      email: userEmail,
      companyId: this.companyId,
    };
    CompanyService.invite(this.companyId, invitation)
    .then(() => {
      $tszToast.showSuccess(`Se enviado una invitación al correo electrónico ${userEmail}`);
    }).catch(() => {
      $tszToast.showError(`No se ha podido enviar la invitación a ${userEmail}`);
    });
  };

  this.loadCompanyUsers(this.companyId);
}

export default {
  template,
  bindings: {
    companyId: '<',
    email: '<',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-team/tsz-team.js